/**
 * HUD: knappar för de tre armélägena (följ / attackera / försvara).
 * Attack/defend får full effekt i mål 2 när strid finns; kommandot och
 * sim-fältet finns redan nu (regel 5: samma kommandomodell hela vägen).
 */
import type { Stance, PlayerId, GameState } from '../sim/state';
import type { InputHandler } from './input';

const STANCES: { stance: Stance; label: string }[] = [
  { stance: 'follow', label: 'Följ skeppet' },
  { stance: 'attack', label: 'Attackera' },
  { stance: 'defend', label: 'Försvara basen' },
];

export class Hud {
  private buttons = new Map<Stance, HTMLButtonElement>();
  private tickLabel: HTMLElement;

  constructor(
    host: HTMLElement,
    input: InputHandler,
    localPlayer: PlayerId,
    private readonly ticksPerSecond: number,
  ) {
    const bar = document.createElement('div');
    bar.className = 'hud-bar';

    for (const { stance, label } of STANCES) {
      const btn = document.createElement('button');
      btn.textContent = label;
      btn.className = 'hud-btn';
      btn.addEventListener('click', () => {
        input.push({ type: 'SetStance', playerId: localPlayer, stance });
        this.setActive(stance);
      });
      this.buttons.set(stance, btn);
      bar.appendChild(btn);
    }

    this.tickLabel = document.createElement('span');
    this.tickLabel.className = 'hud-info';
    bar.appendChild(this.tickLabel);

    host.appendChild(bar);
    this.setActive('follow');
  }

  private setActive(stance: Stance): void {
    for (const [s, btn] of this.buttons) btn.classList.toggle('active', s === stance);
  }

  update(state: GameState): void {
    const seconds = Math.floor(state.tick / this.ticksPerSecond);
    const mm = String(Math.floor(seconds / 60)).padStart(2, '0');
    const ss = String(seconds % 60).padStart(2, '0');
    this.tickLabel.textContent = `${mm}:${ss} · units: ${state.units.length}`;
  }
}
